var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-md-4" }, [
      _c("h1", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.titulo) + " "),
        _c("small", [_vm._v(_vm._s(_vm.subtitulo))]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-4" }, [
      _c(
        "label",
        {
          staticStyle: {
            width: "100%",
            "text-align": "right",
            padding: "9px 0px",
            "font-size": "13px",
            "font-weight": "600",
          },
          attrs: { id: "lblMsgmColeta" },
        },
        [_vm._v("\n        " + _vm._s(_vm.mensagemColeta) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-2" }, [
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.permiteColetar,
              expression: "permiteColetar",
            },
          ],
          staticClass: "btn btn-block btn-primary",
          attrs: { id: "btnColetar", disabled: _vm.desabilitaColeta },
          on: {
            click: function ($event) {
              return _vm.coletarClick()
            },
          },
        },
        [_vm._v("\n        Coletar\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-2" }, [
      _c("div", { staticClass: "form-group" }, [
        _c(
          "div",
          { staticClass: "input-group", attrs: { id: "inptCompetencia" } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dataComp,
                  expression: "dataComp",
                },
              ],
              staticClass: "aga-date datepicker form-control",
              attrs: {
                autocomplete: "off",
                "data-name": "Competencia",
                type: "text",
                "data-type": "date",
                "data-clear-btn": "true",
                maxlength: "7",
                placeholder: "mm/aaaa",
                "data-date-format": "mm/yyyy",
                "data-date-min-view-mode": "months",
                "data-date-start-view": "year",
              },
              domProps: { value: _vm.dataComp },
              on: {
                change: function ($event) {
                  return _vm.competenciaChange($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.dataComp = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm._m(0),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-btn" }, [
      _c(
        "button",
        { staticClass: "btn btn-default btn-sm", attrs: { type: "button" } },
        [_c("i", { staticClass: "fa fa-calendar" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }